<template>
  <div class="min-h-screen bg-primary-foreground">
    <main>
      <!-- Pass dynamic logo to Header -->
      <Header :logo="currentLogo" class="max-w-sm mx-auto" />

      <router-view />
        
      <button
        class="scroll-to-top"
        :class="{ hidden: !showScrollButton }"
        @click="scrollToTop"
        aria-label="Scroll to top"
      >
        <!-- <ArrowUp class="text-[#ffffff]" /> -->
      </button>
    </main>
  </div>
</template>

 <script setup lang="ts">
import Header from '@/components/layout/Header.vue'
import { ref, watch } from 'vue'
// import { ArrowUp } from 'lucide-vue-next'
import { useSimpleScroll } from '@/composables/useSimpleScroll'
import { useRoute } from 'vue-router'
import { useResourcesStore } from '@/stores/resource'
import { storeToRefs } from 'pinia'

// logos
import DefaultLogo from '@/assets/kiddocare-logo-padded.png'
// import OmbakLogo from '@/assets/ombak-brand.png'

const {logo} = storeToRefs(useResourcesStore()) 
const { scrollToTop } = useSimpleScroll()
const route = useRoute()


// current logo state
const currentLogo = ref(DefaultLogo)

// watch slug param and update logo
watch(
  () => route.params.slug as string | undefined,
  (slug) => {
    // console.log('slug', slug)
    //get image from the cdn 
    currentLogo.value = slug && logo.value ? logo.value[slug] : DefaultLogo
    console.log('logo', logo.value)
  },
  { immediate: true }
)

const showScrollButton = ref(false)
</script>


<style>
/* .scroll-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 45px;
  height: 45px;
  background: #147414;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  z-index: 1000;
  color: white;
  font-size: 24px;
} */
</style>
